<div class="mod-header">
    <div class="mod-logo">
        <div class="m-logo m-logo--siemens js-logo js-logo-siemens">
            <a (click)="gotoStartPage()" role="button" tabindex="0"></a>
        </div>
    </div>

    <div class="mod-navigation mod-navigation--icons">
        <div class="m-icon m-icon--menu-items language-selector" (click)="openLanguageSelection()">
            <div class="m-icon-label">
                <span class="material-icons">language</span>
            </div>

            <div class="mat-elevation-z4 language-dropdown" [class.show-lang-sel]="showLanguageSelection()">
                <ul role="menu">
                    @for (lang of availableLanguages; track lang) {
                        <li
                            class="lang-item"
                            (click)="changeLanguage(lang)"
                            (keydown.enter)="changeLanguage(lang)"
                            role="menuitem"
                            tabindex="0"
                            [attr.aria-selected]="languageSelected() === lang"
                        >
                            <p>
                                <i class="material-icons check-icon" [class.selected]="languageSelected() === lang">
                                    done
                                </i>
                                {{ lang.toUpperCase() }}
                            </p>
                        </li>
                    }
                </ul>
            </div>

            <p class="selected-language">{{ languageSelected().toUpperCase() }}</p>
        </div>
    </div>
</div>
